import React from 'react';
import PropTypes from 'prop-types';

function FavoritesHeader (props) {
  const title = props.title || 'Избранное';
  const count = props.totalCount || 0;

  return (
    <div className='search-header'>
      <h1 className='h1'>
        {title}
      </h1>
      <div className='sub-header'>
        <span className='count'>Всего объявлений: {count}.</span>
      </div>
    </div>
  );
}

FavoritesHeader.propTypes = {
  totalCount: PropTypes.number,
  title: PropTypes.string
};

FavoritesHeader.defaultProps = {
  totalCount: null,
  title: null
};

export default FavoritesHeader;



// WEBPACK FOOTER //
// ./src/ui/Header/FavoritesHeader.jsx